import { render, staticRenderFns } from "./veStuStipendEdit.vue?vue&type=template&id=159bdf1f&scoped=true"
import script from "./veStuStipendEdit.vue?vue&type=script&lang=js"
export * from "./veStuStipendEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159bdf1f",
  null
  
)

export default component.exports